import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isUserAuthenticatedSelector } from '../../selectors';
import { getStateValueForActiveUserSession } from '../../utils/urlUtils';
import { connect } from 'react-redux';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { getAuthenticatedUser, redirectToReportingPortalForRegistration } from '../../api/authApi';
import * as authActions from '../../actions/authActions';
import { bindActionCreators } from 'redux';
import Logout from '../Logout';
import { Route } from 'react-router-dom';
import LayoutAuthenticated from '../LayoutAuthenticated';
import LayoutUnauthenticated from '../LayoutUnauthenticated';
import ResponseBanner from 'Components/cards/ResponseBanner';
import Maintenance from 'Components/Maintenance/Maintenance';
import UserInactive from 'Components/UserInactive/UserInactive';
import { getUrlSearchParamValue } from 'Utils/urlUtils';
import {
  clearLogoutSettings,
  getLockedImages,
  clearLockedImageArray,
} from 'Utils/localStorageUtils.js';
import { loginHook } from './loginHook';
import NoSupportIE11 from 'Components/NoSupportIE11';
import { updateTimeForLockedImages } from 'Apis/queueManagerApi.js';
import { pendoInitializer, logRocketSessionInitializer } from 'Components/session/session.js';
import { getPaperlessFlow, getPaperlessRedirectionToReporting, getRegionfromSessionStorge, removePaperlessRedirectionToReporting, setPaperlessInSessionStorge } from '../../../../dims-common-ui/components/utils_paperless_flow/PaperlessCommon';
import InactivePaperlessForm from '../InactivePaperlessForm/InactivePaperlessForm';
import { USERS } from '../../utils/constants/appConstants.js';
import { VITE_isIE, VITE_NEW_AUTH_TOKEN_TIME, VITE_MAINTENANCE_LOGIN_TOKEN, VITE_LOGROCKET_APP_ID, VITE_CITI_BRANDED_URL, VITE_DAI_AP_CAMPAIGN_END_DATE, VITE_DAI_CA_CAMPAIGN_END_DATE, VITE_DAI_EU_CAMPAIGN_END_DATE, VITE_DAI_US_CAMPAIGN_END_DATE, VITE_EVO_BRANDED_URL,VITE_GPE_BRANDED_URL } from 'Constants/appEnvConstants';
import { getGpAuthLoginToken, initAuthServiceForCrossTab } from 'Components/session/gpAuthService';
import { isEmpty, isNull } from 'Utils/lodashUtils';
import ImagePortal from '../ImagePortal/ImagePortal';

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isValidTokenInRequest: false,
      showLoginErrorBanner: false,
      acquirerCode : null,
      isUserInactive: false,
      menuClicked: false,
      inMaintenance: true,
      isPaperlessCampaignEnd:true,
      userAcquirerCodes: [],
      appPortal: ''
    };
    this.attachBindings();
  }

  attachBindings() {
    this.logout = this.logout.bind(this);
    this.showLoginErrorBanner = this.showLoginErrorBanner.bind(this);
    this.getAppPortalDetails = this.getAppPortalDetails.bind(this);
    this.getCrossApplicationLoginDetails = this.getCrossApplicationLoginDetails.bind(this);
  }

  redirectToMaintenancePage() {
    const currentServer = window.location.host;
    const maintenanceRedirectUrl = `/maintenance`;
    this.props.history.push(maintenanceRedirectUrl);
    // window.location = maintenanceRedirectUrl;  // commenting code for sast scan
  }

  redirectToInactivePaperlessForm(){
    const inactivePaperless = `/inactivePaperless`;
    this.props.history.push(inactivePaperless);
  }

  redirectToUserInactivePage(){
    const userInactiveRedirectUrl = `/inactive`;
    this.props.history.push(userInactiveRedirectUrl);
  }
  
  redirectToUserInactivePage(){
    const userInactiveRedirectUrl = `/inactive`;
    this.props.history.push(userInactiveRedirectUrl);
  }

  isDAICampaignEndRegionSpecific(){
    const currentdate = new Date();
    if(getRegionfromSessionStorge() === 'us' && currentdate > new Date(VITE_DAI_US_CAMPAIGN_END_DATE))
      return true;
    else if(getRegionfromSessionStorge() === 'ca' && currentdate > new Date(VITE_DAI_CA_CAMPAIGN_END_DATE))
      return true;
    else if(getRegionfromSessionStorge() === 'ap' && currentdate > new Date(VITE_DAI_AP_CAMPAIGN_END_DATE))
      return true;
    else if(getRegionfromSessionStorge() === 'eu' && currentdate > new Date(VITE_DAI_EU_CAMPAIGN_END_DATE))
      return true;
    else 
      return false; 
  }

  beforeLoading =  () => {
    if (!sessionStorage.length || (sessionStorage.length == 1 && sessionStorage.getItem('pendo_tabId'))) {
    // Ask other tabs for session storage
     localStorage.setItem('getSessionStorage', Date.now());
    }
    
    window.addEventListener('storage',   (event) => {
      if (event.key == 'getSessionStorage') {
        localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
        localStorage.removeItem('sessionStorage');

      } else if (event.key == 'sessionStorage' && (!sessionStorage.length 
        || (sessionStorage.length == 1 && sessionStorage.getItem('pendo_tabId')))) {
        var data = JSON.parse(event.newValue).state;
        // sessionStorage.setItem('accessToken', JSON.parse(data).auth.accessToken);
      }
    })    
    
  }

  componentWillMount = () => {
    this.beforeLoading();
    let waitTime = 2000;
    if(getPaperlessRedirectionToReporting()){
        removePaperlessRedirectionToReporting();
        waitTime = 15000;
      }
    setTimeout(()=>{
        this.initialLoading()
      },waitTime )
  }

  getAppPortalDetails(appURL) {
    if(appURL.includes(VITE_CITI_BRANDED_URL)) {
      return "CITI";
    }else if(appURL.includes(VITE_GPE_BRANDED_URL)){
      return "GPE";
    }
    else {
      return "GPN";
    }
  }
  

  getCrossApplicationLoginDetails(userAcquirerCodeList) {
    switch (this.state?.appPortal) {
      
      case "CITI":
        return !(userAcquirerCodeList?.includes("GPN") || userAcquirerCodeList?.includes("CIT"));

      case "GPE":
        return !(userAcquirerCodeList?.includes("GPE") || userAcquirerCodeList?.includes("GPN"));
        
      default:
        const blockedCodes = ["GPN", "MXP", "HPY", "EMD"];
        return !blockedCodes.some(code => userAcquirerCodeList?.includes(code));
    }
  }
  
  initialLoading = async () => { 
    let maintenanceToken = getUrlSearchParamValue(this.props.location.search, 'maintenanceToken');
    const searchParameterValue = `${window.location.search}`;
    if (searchParameterValue != null && searchParameterValue.includes('?source=account')) {
      sessionStorage.setItem('accountRedirection', true);
    } else if (searchParameterValue != null && searchParameterValue.includes('?source=EVO')) {
      sessionStorage.setItem('evoRedirection', true);
    }
    // Initialize auth service in EVERY tab for BroadcastChannel cross-tab logout
    // This must happen BEFORE checking for token, so secondary tabs also get BroadcastChannel
    initAuthServiceForCrossTab();
    if(!sessionStorage.getItem("__gp_auth_token__")){
      await getGpAuthLoginToken();
    }
    let accessToken = sessionStorage.getItem("__gp_auth_token__");
    if (!accessToken)
        window.location.reload();

    //in the case of paperless URL 
    const pathURI = `${window.location.pathname}`;
    setPaperlessInSessionStorge(pathURI);
    console.log(getPaperlessFlow(), 'checking session storage in app investigator');

    console.log("investigator : before geeting from session storage===", sessionStorage.getItem("__gp_auth_token__"))
    if (sessionStorage.getItem("__gp_auth_token__")) {
      console.log(" investigator : access token key found from session storage", sessionStorage.getItem("__gp_auth_token__"));
      accessToken = sessionStorage.getItem("__gp_auth_token__");
    }

    const redirectUri = `https://${window.location.hostname}`;
    this.setState({ appPortal: this.getAppPortalDetails(redirectUri) || "" })
    const appPortal = (sessionStorage.getItem('evoRedirection') === "true") ? "EMD" : this.getAppPortalDetails(redirectUri);
    sessionStorage.setItem('appPortal', appPortal);
    this.setState({ appPortal: sessionStorage.getItem('appPortal') });
    document.title = redirectUri.includes(VITE_CITI_BRANDED_URL) ? 'Chargeback Merchant Portal' : 'Disputes Management';

    if (!this.props.isUserAuthenticated && !accessToken && VITE_isIE) {
      this.state = {
        isLoading: false,
        isValidTokenInRequest: false,
        isIE11: true,
      };
      this.props.history.push('/ie11');
      return;
    } else if (IN_MAINTENANCE === 'true' && VITE_MAINTENANCE_LOGIN_TOKEN != maintenanceToken) {
      this.setState({
        isLoading: false,
        isValidTokenInRequest: false,
        inMaintenance: true,
      });
      this.redirectToMaintenancePage();
    } else if (getPaperlessFlow() && this.isDAICampaignEndRegionSpecific()) {
      this.setState({
        isLoading: false,
        isValidTokenInRequest: false,
        isPaperlessCampaignEnd: true,
      });
      this.redirectToInactivePaperlessForm();
    } else if ((!this.state.isUserInactive || this.props.isUserAuthenticated) && this.state.acquirerCode == null) {
      this.setState({
        inMaintenance: false,
        isPaperlessCampaignEnd: false,
      });

      const { INTERNAL_USERS, EXTERNAL_USERS } = USERS;

      let user;
      if (document.referrer.includes('merchant'))
        this.logout();
      if (!this.props.isUserAuthenticated) {
        console.log("investigator: User is not authenticated");
        if (accessToken) {
          console.log("investigator: User is not authenticated and found access token");
          getAuthenticatedUser(accessToken, false)
            .then((userResponse) => {
              console.log("investigator : getAuthenticatedUser call success");
              if (userResponse.data) {
                user = !accessToken && isEmpty(userResponse.data) && !isNull(this.props?.auth?.session) ?
                  this.props?.auth?.user : {... userResponse?.data};
                user = { ...user, role: { ...user.role, key: user.role.key.trim() } };

                if (user.status == 'Inactive') {
                  this.setState({
                    isLoading: false,
                    isUserInactive: true,
                    isValidTokenInRequest: false,
                    menuClicked: false
                  });
                  this.redirectToUserInactivePage();
                  return;
                }
                const isExternalUser = EXTERNAL_USERS.includes(user.role.key);
                const isInternalUser = INTERNAL_USERS.includes(user.role.key);

                clearLogoutSettings();
               if(this.getCrossApplicationLoginDetails(user.acquirerCode)){
                  console.log("investigator : crossApplicationLogin");   
                  this.setState({showLoginErrorBanner: true, isLoading: false})
                  this.logout();
                  return;
                }

                if (redirectUri.includes(VITE_CITI_BRANDED_URL)) {
                  if (isExternalUser) {
                    getStateValueForActiveUserSession();
                    location.assign(`${VITE_CITI_BRANDED_URL}/merchant`);
                  }
                  else {
                    this.setState({ showLoginErrorBanner: true, isLoading: false })
                    this.logout();
                  }
                }

                if (redirectUri.includes(VITE_EVO_BRANDED_URL)) {
                  if (isExternalUser) {
                    getStateValueForActiveUserSession();
                    location.assign(`${VITE_EVO_BRANDED_URL}/merchant`);
                  }
                  else {
                    this.setState({ showLoginErrorBanner: true, isLoading: false })
                    this.logout();
                  }
                }

                if (isExternalUser) {
                  console.log("investigator : isExternalUser");
                  getStateValueForActiveUserSession();
                  location.assign(`${window.location.protocol}//${window.location.host}/merchant`);
                }
                // else if (hasStaleAuthProviderSession()) {
                //   this.props.authProvider.signoutFromProvider();
                // }

                else if (isInternalUser) {
                  this.props.authActions.loginSuccess(user);
                  this.props.authActions.updateTokenExpirationTime(Date.now() + (VITE_NEW_AUTH_TOKEN_TIME));
                  this.setState({ isValidTokenInRequest: true, isLoading: false });
                  this.props.session.login();
                }

                else {
                  console.log("investigator : logging out ");
                  this.setState({ showLoginErrorBanner: true, isLoading: false })
                  this.logout();
                }

              } else {
                console.log("investigator : Error retrieving user");
                this.setState({ isLoading: false })
                const getAuthenticatedUserError = new Error('Error retrieving user.');
                throw getAuthenticatedUserError;
              }
            })
            .catch((userResponse) => {
              console.log("in catch of auth call investigator")
              if (getPaperlessFlow()) {
                console.warn('is paperless flow from app');
                redirectToReportingPortalForRegistration();
              } else {
                console.log("Unable to perform authentication, logging out.");
                this.setState({ showLoginErrorBanner: true, isLoading: false })
                console.log("print this.props: ", this.props);
                this.logout();
              }
            });
          this.props.authActions.setAuthToken(accessToken);
          this.updateTimeForLockedImages();
          console.log("investigator :after updateTimeForLockedImages");
          if (!sessionStorage.getItem("__gp_auth_token__")) {
            this.props.history.replace('/');
          }
          else {
            this.setState({ isLoading: false });
            console.log("investigator : in else part of getAuthenticatedUser call");
          }
        } else {
          this.setState({ isLoading: false });
          console.log("investigator : in else if user is not authenticated");
        }
      }
      else if (sessionStorage.getItem("state")) {
        console.log("accessToken found in session storage");
        let auth = JSON.parse(sessionStorage.getItem("state")).auth;
        console.log("logging auth in case of state---", auth);
        if (auth.user === undefined) {
          // accessToken = accessToken ? accessToken : auth.accessToken;
          console.log("investigator : if session storage have state");
          getAuthenticatedUser(accessToken, false)
            .then((userResponse) => {
              console.log("investigator : if session storage have state and getAuthenticatedUser call");
              if (userResponse.data) {
                console.log("investigator : in case of state getting user response");
                console.log('Creating user');
                user = accessToken === undefined && userResponse.data === undefined && this.props.auth.session !== null ?
                  this.props.auth.user : Object.assign({}, userResponse.data);

                user = { ...user, role: { ...user.role, key: user.role.key.trim() } };

                const isExternalUser = EXTERNAL_USERS.includes(user.role.key);
                const isInternalUser = INTERNAL_USERS.includes(user.role.key);

                clearLogoutSettings();

                if(this.getCrossApplicationLoginDetails(user.acquirerCode)){
                  console.log("investigator : in case of state,crossApplicationLogin ");   
                  this.setState({showLoginErrorBanner: true, isLoading: false})
                  this.logout();
                  return;
                }

                if (redirectUri.includes(VITE_CITI_BRANDED_URL)) {
                  if (isExternalUser)
                    location.assign(`${VITE_CITI_BRANDED_URL}/merchant`);
                  else {
                    this.setState({ showLoginErrorBanner: true, isLoading: false })
                    this.logout();
                  }
                }

                if (redirectUri.includes(VITE_EVO_BRANDED_URL)) {
                  if (isExternalUser)
                    location.assign(`${VITE_EVO_BRANDED_URL}/merchant`);
                  else {
                    this.setState({ showLoginErrorBanner: true, isLoading: false })
                    this.logout();
                  }
                }

                if (isExternalUser) {
                  console.log("investigator : in case of state,isExternalUser");
                  location.assign(`${window.location.protocol}//${window.location.host}/merchant`);
                }

                // else if (hasStaleAuthProviderSession()) {
                //   this.props.authProvider.signoutFromProvider();
                // }
                else if (isInternalUser) {
                  this.props.authActions.loginSuccess(user);
                  this.props.authActions.updateTokenExpirationTime(Date.now() + (VITE_NEW_AUTH_TOKEN_TIME));
                  this.setState({ isValidTokenInRequest: true, isLoading: false });
                  this.props.session.login();
                }

                else {
                  console.log("investigator : in case of state,logging out");
                  this.setState({ showLoginErrorBanner: true, isLoading: false })
                  this.logout();
                }

              } else {
                console.log("investigator : in case of state,Error retrieving user.");
                this.setState({ isLoading: false });
                const getAuthenticatedUserError = new Error('Error retrieving user.');
                throw getAuthenticatedUserError;
              }
            })
            .catch((userResponse) => {
              console.log("investigator : if state not found in catch block");
              if (getPaperlessFlow()) {
                console.warn('is paperless flow from in case of state check');
                redirectToReportingPortalForRegistration();
              } else {
                this.setState({ showLoginErrorBanner: true, isLoading: false })
                this.logout();
              }
            });
        }
        else {
          logRocketSessionInitializer(accessToken || auth.accessToken || "");
          console.log('********* Logrocket identified *********');
          //re-initialize pendo when user does a refresh
          pendoInitializer(accessToken || auth.accessToken || "");
          console.log('********* Pendo initialized from App component *********');

          const isExternalUser = EXTERNAL_USERS.includes(auth.user.role.key.trim());
          const isInternalUser = INTERNAL_USERS.includes(auth.user.role.key.trim());

          if (this.getCrossApplicationLoginDetails(auth.user.acquirerCode)) {
            console.log("investigator : after state check,crossApplicationLogin ");
            this.setState({ showLoginErrorBanner: true, isLoading: false })
            this.logout();
          }

          if (redirectUri.includes(VITE_CITI_BRANDED_URL)) {
            if (isExternalUser)
              location.assign(`${VITE_CITI_BRANDED_URL}/merchant`);
            else {
              this.setState({ showLoginErrorBanner: true, isLoading: false })
              this.logout();

            }
          }

          if (redirectUri.includes(VITE_EVO_BRANDED_URL)) {
            if (isExternalUser)
              location.assign(`${VITE_EVO_BRANDED_URL}/merchant`);
            else {
              this.setState({ showLoginErrorBanner: true, isLoading: false })
              this.logout();

            }
          }

          if (isExternalUser) {
            console.log("investigator : after state check,location assigning to merchant");
            location.assign(`${window.location.protocol}//${window.location.host}/merchant`);
          }

          else if (isInternalUser) {
            this.setState({ isValidTokenInRequest: true, isLoading: false });
            logRocketSessionInitializer(accessToken || auth.accessToken || "");
            console.log('********* Logrocket identified *********');
            pendoInitializer(accessToken || auth.accessToken || "");
            console.log('********* Pendo initialized from App component *********');
          }
          else {
            console.log("investigator : logging out at end");
            this.setState({ showLoginErrorBanner: true, isLoading: false })
            this.logout();
          }
        }
      }
    }
  }

  logout(){
    this.props.history.push('/logout');
  }

  showLoginErrorBanner() {
    return (
      <div>
      <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title="System Error: "
          description="Unable to fetch authorization details of user."
          type="danger"
          onClose={this.logout}
          cancelOnly
          cancelButtonText="DISMISS"
          primaryButtonActionValue=""
        />
        </ImagePortal>
      </div>
    );
  }

  // updateTimeForLockedCases() {
  //   let uniqueLockedCases = [];
  //   getLockedCases().forEach(element => {
  //     let index = uniqueLockedCases.findIndex(data => data.caseNumber === element.caseNumber && data.caseStageId === element.caseStageId);
  //     if (index === -1) {
  //       uniqueLockedCases = uniqueLockedCases.concat({
  //         caseNumber: element.caseNumber,
  //         caseStageId: element.caseStageId
  //       });
  //     }
  //   });
  //   if (uniqueLockedCases.length > 0) {
  //     updateTimeForLockedCases(uniqueLockedCases)
  //       .then((apiRespose) => {
  //         clearLockedCaseArray();
  //       })
  //       .catch((error) => {
  //         console.log("error while updating the recently locked case ", error);
  //       })
  //   }
  // }

  updateTimeForLockedImages() {
    let uniqueLockedImages = [];
    getLockedImages().forEach(element => {
      let index = uniqueLockedImages.findIndex(data => data.documentId === element.documentId);
      if (index === -1) {
        uniqueLockedImages = uniqueLockedImages.concat(element.documentId);
      }
    });
    if (uniqueLockedImages.length > 0) {
      updateTimeForLockedImages(uniqueLockedImages)
        .then((apiRespose) => {
          clearLockedImageArray();
        })
        .catch((error) => {
          console.log("error while updating the recently locked image ", error);
        })
    }
  }

  render() {
    const { isLoading, isValidTokenInRequest } = this.state;
    return (
      isLoading ? (<BVLoader20 />) : (
        <div className="layout-wrapper" style={{ overflowX: 'hidden' }}>
          <Route
            exact
            path="/logout"
            render={(props) => (
              <Logout {...props} />
            )}
          />
          <Route
            path="/maintenance"
            render={(props) => (
            <Maintenance {...props} />
            )}
          />
          <Route
            path="/ie11"
            render={(props) => (
            <NoSupportIE11 {...props} />
            )}
          />
           <Route
            path="/inactive"
            render={(props) => (
              <UserInactive {...props} />
            )}
          />
          <Route
            path="/inactivePaperless"
            render={(props) => (
              <InactivePaperlessForm {...props} />
            )}
          />
          {this.state.showLoginErrorBanner && this.showLoginErrorBanner()}
          {!this.props.isUserAuthenticated && !isValidTokenInRequest && !this.state.isPaperlessCampaignEnd && !this.state.inMaintenance && !this.state.isIE11 && !this.state.isUserInactive && <LayoutUnauthenticated />}
          {this.props.isUserAuthenticated && isValidTokenInRequest && !this.state.inMaintenance && !this.state.isPaperlessCampaignEnd && !this.state.isIE11 && !this.state.isUserInactive && <LayoutAuthenticated />}
        </div>)
    );
  }
}

App.propTypes = {
  location: PropTypes.object.isRequired,
  isUserAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isUserAuthenticated: isUserAuthenticatedSelector(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch),
    newLogin: () => {
      dispatch(authActions.newLogin());
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(loginHook(App)));
